import { render } from "./TrackYourSpendPage.vue?vue&type=template&id=6d7a7be4&scoped=true"
import script from "./TrackYourSpendPage.vue?vue&type=script&lang=js"
export * from "./TrackYourSpendPage.vue?vue&type=script&lang=js"

import "./TrackYourSpendPage.vue?vue&type=style&index=0&id=6d7a7be4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7a7be4"]])

export default __exports__